import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Pagination } from './pagination';

interface PaginationProps {
  pageSizes: number[];
  pageSize: number;
  page: number;
  totalItems: number;
  onChange: (pagination: { page: number; pageSize: number }) => void;
  itemRangeText: (min: number, max: number, total: number) => string;
  pageRangeText: (current: number, total: number) => string;
}

// PersistentPagination Component
export const PersistentPagination: React.FC<PaginationProps> = ({
  pageSizes,
  pageSize,
  page,
  totalItems,
  onChange,
  itemRangeText,
  pageRangeText,
}) => {
  const location = useLocation();
  const history = useHistory();

  // Read `page` from the query string
  const query = new URLSearchParams(location.search);
  const currentPage = parseInt(query.get('page') || String(page), 10);

  // Update URL when the page changes
  const handlePageChange = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    query.set('page', String(page));
    history.push({ pathname: location.pathname, search: query.toString() });
    onChange({ page, pageSize });
  };

  return (
    <Pagination
      pageSizes={pageSizes}
      pageSize={pageSize}
      page={currentPage}
      totalItems={totalItems}
      onChange={handlePageChange}
      itemRangeText={itemRangeText}
      pageRangeText={pageRangeText}
    />
  );
};
